module.exports = __webpack_public_path__ + "img/noimage.fc17754d.png";